//import type { LangKey } from '@airwallex/core/dist/global';
import { getLangKey } from '@airwallex/core/dist/webapp-auth-client';
// import type { FlowContextType } from '@airwallex-dev-scale/core/dist/hosted-flow-utils';
import { useFlowContext } from '@airwallex-dev-scale/core/dist/hosted-flow-utils';
import type { FC } from 'react';
import { createContext, useContext, useEffect } from 'react';

//import { airTracker } from '@/utils/airTracker';

export const AppFlowContext = createContext<{
  hideNav: boolean;
  hideHeader: boolean;
  isEmbedded: boolean;
  isNativeHosted: boolean;
  isWebHosted: boolean;
  contactUsUrl: string;
  brandName: string;
  langKey: any;
  type: any | undefined;
}>({
  hideNav: false,
  hideHeader: false,
  isEmbedded: false,
  isNativeHosted: false,
  isWebHosted: false,
  contactUsUrl: '',
  brandName: '',
  langKey: 'en' as any,
  type: undefined,
});

export const AppFlowProvider: FC = ({ children }:any) => {
  const { type, options } = useFlowContext();
  const isEmbedded = type === 'EMBEDDED';
  const isNativeHosted = type === 'NATIVE_HOSTED';
  const isWebHosted = type === 'WEB_HOSTED';
  const hideNav = isEmbedded && (options?.hideNav as boolean);
  const hideHeader = isEmbedded && (options?.hideHeader as boolean);
  const langKeyInStorage = getLangKey();
  const langKeyInOption = (options?.langKey ?? 'en') as any;
  const langKey = isEmbedded ? langKeyInOption : langKeyInStorage;
  const contactUsUrl =
    (options?.contactUrl as Record<string, string>)?.[langKey as string] ?? '';
  const brandName =
    (options?.brandName as Record<string, string>)?.[langKey as string] ?? '';

  useEffect(() => {
/*     airTracker.info('AppFlow', {
      langKey,
      brandName,
      type,
    }); */
  }, []);

  return (
    <AppFlowContext.Provider
      value={{
        hideNav,
        isEmbedded,
        isNativeHosted,
        isWebHosted,
        hideHeader,
        contactUsUrl,
        brandName,
        langKey,
        type,
      }}
    >
      {children}
    </AppFlowContext.Provider>
  );
};

export const useAppFlowContext = () => useContext(AppFlowContext);
